import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { ɵc, EventService } from '@crystalui/angular-lightbox';
import { Icons } from '@vex/icons/icons';
import { AuthService } from '@vex/http-service/auth.service';
import { DateFormatPipe } from '@vex/pipes/date-format/date-format.pipe';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { MdePopoverTrigger } from '@material-extended/mde';
import { DependencyMapService } from '@vex/http-service/dependency-map.service';
import { BluePrintStateService } from '@vex/constants/bluepirnt-state';
import { InventoryType } from '@vex/model/blueprint-list';
import { EnvironmentType } from '@vex/model/dependency-map';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'inventory-card-full-width',
  templateUrl: './inventory-card-full-width.component.html',
  styleUrls: ['./inventory-card-full-width.component.scss'],
  providers: [DateFormatPipe, ɵc, EventService]
})
export class InventoryCardFullWidthComponent extends Icons implements OnInit, OnDestroy {
  @Input() inventory: any;
  @Input() isDriftedAndImportedShow: boolean = true;
  @ViewChild('target', { static: false }) target: MdePopoverTrigger;
  providers: any[] = [];
  value: string = '';
  label: string = '';
  state: any = {};
  cloudName: string = '';
  InventoryType = InventoryType;
  bindDefaultImage: boolean = false;
  private destroy$ = new Subject<void>();
  inventoryType:any;
  version:any;
  showIpam: boolean = false;

  constructor(
    private stateService: BluePrintStateService,
    private cloudConnectStateService: CloudConnectStateService,
    private dependencyMapService: DependencyMapService,
    private router: Router,
    private authService: AuthService
  ) {
    super();
  }

  showTooltip(value, label) {
    this.value = value;
    this.label = label;
  }

  isAccess(id) {
    return this.authService.getRights('ActionIds', id);
  }

  openDetails() {
    if (this.isAccess('67535af9ce0af7b4dfb493e2')) {
      if(this.inventory?.Id){
        let url = `/network-management/jobs?id=${this.inventory?.Id}`;
        window.open(url, '_blank');
      }
    }
  }

  getState(state: number) {
    this.state = this.stateService.getState(state);
  }

  getInventoryType(type) {
    if (this.InventoryType.Instance === type) {
      return 'Instance'
    }
    if (this.InventoryType.Gateway === type) {
      return 'Gateway';
    }
    if (this.InventoryType.Iac === type) {
      return 'Code File';
    }
  }

  getVersion() {
    return Number(this.inventory.Version || '1') > 1;
  }

  mapData() {
    // this.inventory['provider'] = this.providers?.find((x) => x.Id == this.inventory.ProviderId)?.Name || '';
    this.inventory['createDate'] = this.inventory.CreatedDate ? this.inventory.CreatedDate : this.inventory.UpdatedDate;
    this.inventory['updateDate'] = this.inventory.UpdatedDate ? this.inventory.UpdatedDate : this.inventory.CreatedDate;
    this.inventory['createBy'] = this.inventory.CreatedBy ? this.inventory.CreatedBy : this.inventory.UpdatedBy;
    this.inventory['updateBy'] = this.inventory.UpdatedBy ? this.inventory.UpdatedBy : this.inventory.CreatedBy;
  }

  getProvider() {
    this.dependencyMapService.getDependencyMapsForSelect().pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        this.providers = response;
        const dependencyMapId = this.inventory?.ProviderId ||
          this.inventory?.Blueprint?.BlueprintContainers?.[0]?.DependencyMapId;
        const dependencyMap = this.providers?.find((provider) => provider.Id === dependencyMapId);
        this.showIpam = dependencyMap?.IntegrateWithIpam === true;
        this.mapData();
      },
      (error) => {
      }
    );
  }

  isDataCenter(){
    return this.cloudConnectStateService.getEnvironmentType(this.cloudName) == EnvironmentType.DataCenter;
  }

  getImageByCloudKey() {
    return this.cloudConnectStateService.getImageByCloudKey(this.cloudName);
  }

  getDefaultImage(cloudName) {
    return this.cloudConnectStateService.getDefaultImageByCloud(cloudName, 'inventory');
  }

  goToBlueprint() {
    if (!this.inventory.Imported) {
      this.router.navigate([
        '/network-management/blueprintdesigner/edit/',
        this.inventory.Blueprint.Id
      ]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.inventory.InventoryType = this.inventory?.InventoryType || this.InventoryType.Instance;
    if (this.inventory.InventoryType == 2) {
      this.cloudName = this.inventory.Clouds[0];
    } else {
      this.cloudName = this.inventory?.Blueprint?.CloudName;
      if(!this.cloudName) {
        this.cloudName = this.inventory?.Blueprint?.BlueprintContainers[0].Name;
      }
    }
    this.inventoryType = this.getInventoryType(this.inventory.InventoryType);
    this.version = this.getVersion();
    this.mapData();
    this.getState(this.inventory.State);
    this.getProvider();
  }
}
